var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "modal-card" }, [
    _c("header", { staticClass: "modal-card-head" }, [
      _c("p", { staticClass: "modal-card-title" }, [
        _vm._v(" Save As Profile "),
      ]),
      _c(
        "a",
        {
          staticClass: "close-modal",
          attrs: { "aria-label": "close" },
          on: {
            click: function ($event) {
              return _vm.closeModal()
            },
          },
        },
        [_c("i", { staticClass: "material-icons" }, [_vm._v("close")])]
      ),
    ]),
    _c("section", { staticClass: "modal-card-body" }, [
      _c("p", [
        _vm._v(
          " You can save a profile, if you'd like. But you need to give it a name. "
        ),
      ]),
      _c("h5", [_vm._v(" New Profile Name ")]),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.profileName,
            expression: "profileName",
          },
        ],
        staticClass: "input",
        attrs: { type: "text", placeholder: "Enter profile name..." },
        domProps: { value: _vm.profileName },
        on: {
          input: function ($event) {
            if ($event.target.composing) return
            _vm.profileName = $event.target.value
          },
        },
      }),
      _vm.profileNameExists
        ? _c("div", { staticClass: "warning-box" }, [
            _c("i", { staticClass: "material-icons" }, [_vm._v("warning")]),
            _vm._v(
              " Saving a profile with this name will over-write the existing profile with this name. To save a new copy, change the name above. "
            ),
          ])
        : _vm._e(),
      _c(
        "div",
        { staticClass: "asof-type" },
        [
          _c("h5", [_vm._v("Date")]),
          _vm._l(_vm.asOfOptions, function (type, copy) {
            return _c(
              "div",
              {
                key: type,
                staticClass: "pseudo-selector",
                class: { "pseudo-selector--active": _vm.asOfType === type },
                on: {
                  click: function ($event) {
                    _vm.asOfType = type
                  },
                },
              },
              [
                _c("div", { staticClass: "pseudo-selector__radio" }),
                _vm._v(" Always use " + _vm._s(copy) + " "),
              ]
            )
          }),
        ],
        2
      ),
      _c("div", { staticClass: "buttons-row" }, [
        _c(
          "button",
          {
            staticClass: "button button-secondary button-outline button-medium",
            on: {
              click: function ($event) {
                return _vm.closeModal()
              },
            },
          },
          [_vm._v(" Cancel ")]
        ),
        _c(
          "button",
          {
            staticClass: "button button-primary button-medium",
            attrs: { disabled: !_vm.profileName || _vm.saveLoading },
            on: {
              click: function ($event) {
                return _vm.saveModal()
              },
            },
          },
          [_vm._v(" Save ")]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }